import React from 'react';

export const MulticolorSuccess = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.1" cx="50" cy="50" r="50" fill="#5C6AC4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.5625 18.75C68.8214 18.75 82.8125 32.7411 82.8125 50C82.8125 67.2589 68.8214 81.25 51.5625 81.25C34.3036 81.25 20.3125 67.2589 20.3125 50C20.3125 32.7411 34.3036 18.75 51.5625 18.75Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.1919 25.6831C78.2799 31.4119 82.8125 40.1766 82.8125 50C82.8125 67.2589 68.8214 81.25 51.5625 81.25C41.7391 81.25 32.9743 76.7174 27.2456 69.6295C32.6105 73.9657 39.4395 76.5625 46.875 76.5625C64.1339 76.5625 78.125 62.5714 78.125 45.3125C78.125 37.8771 75.5282 31.0481 71.1919 25.6831V25.6831Z"
      fill="#FFC200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.375 50C84.375 31.8782 69.6843 17.1875 51.5625 17.1875C33.4407 17.1875 18.75 31.8782 18.75 50C18.75 68.1218 33.4407 82.8125 51.5625 82.8125C69.6843 82.8125 84.375 68.1218 84.375 50ZM21.875 50C21.875 33.604 35.1665 20.3125 51.5625 20.3125C67.9585 20.3125 81.25 33.604 81.25 50C81.25 66.396 67.9585 79.6875 51.5625 79.6875C35.1665 79.6875 21.875 66.396 21.875 50Z"
      fill="#154E84"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.1919 25.6831C78.2799 31.4119 82.8125 40.1766 82.8125 50C82.8125 67.2589 68.8214 81.25 51.5625 81.25C41.7391 81.25 32.9743 76.7174 27.2456 69.6295C32.6105 73.9657 39.4395 76.5625 46.875 76.5625C64.1339 76.5625 78.125 62.5714 78.125 45.3125C78.125 37.8771 75.5282 31.0481 71.1919 25.6831V25.6831Z"
      fill="#12C39A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.5625 17.1875C69.6843 17.1875 84.375 31.8782 84.375 50C84.375 68.1218 69.6843 82.8125 51.5625 82.8125C33.4407 82.8125 18.75 68.1218 18.75 50C18.75 31.8782 33.4407 17.1875 51.5625 17.1875ZM51.5625 20.3125C35.1665 20.3125 21.875 33.604 21.875 50C21.875 66.396 35.1665 79.6875 51.5625 79.6875C67.9585 79.6875 81.25 66.396 81.25 50C81.25 33.604 67.9585 20.3125 51.5625 20.3125Z"
      fill="#464AC9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.4391 57.063L40.1262 48.8571C39.512 48.2509 38.5227 48.2573 37.9165 48.8714C37.3103 49.4855 37.3167 50.4748 37.9308 51.0811L47.4594 60.487C48.1126 61.1318 49.1781 61.0774 49.7623 60.3695L65.2337 41.6195C65.7829 40.9539 65.6886 39.9691 65.023 39.4199C64.3573 38.8706 63.3725 38.965 62.8233 39.6306L48.4391 57.063Z"
      fill="#6C63FF"
    />
  </svg>
);
